import api, { ValidateAxiosError } from '@/modules/api.service';
import { isAxiosError } from 'axios';
import { RelatorioComarcasColaboradores } from './relatorio-colaboradores.types';

function normalizarRelatorioColaboradores(data: unknown): RelatorioComarcasColaboradores[] {
  if (Array.isArray(data)) {
    return data as RelatorioComarcasColaboradores[];
  }

  if (typeof data === 'string') {
    const trecho = data.trim().slice(0, 80);
    throw new Error(
      trecho.startsWith('<')
        ? 'A API devolveu HTML em vez de JSON (rota /api/lotacoes-colaborador ausente ou fallback do front). Confirme se o deploy de produção inclui esse endpoint.'
        : `Resposta inválida do relatório de colaboradores por setor: ${trecho || '(vazio)'}`,
    );
  }

  if (data && typeof data === 'object') {
    const obj = data as { objects?: unknown; data?: unknown; message?: unknown };
    if (Array.isArray(obj.objects)) {
      return obj.objects as RelatorioComarcasColaboradores[];
    }
    if (Array.isArray(obj.data)) {
      return obj.data as RelatorioComarcasColaboradores[];
    }
    if (Array.isArray((data as unknown[])[0])) {
      return (data as unknown[])[0] as RelatorioComarcasColaboradores[];
    }
    if (typeof obj.message === 'string' && obj.message.trim()) {
      throw new Error(obj.message.trim());
    }
  }

  throw new Error(
    'Resposta inválida do relatório de colaboradores por setor (esperado um array).',
  );
}

export async function GetRelatorioColaboradoresPorSetor() {
  try {
    const response = await api.get('/lotacoes-colaborador');
    return normalizarRelatorioColaboradores(response.data);
  } catch (error) {
    if (!isAxiosError(error)) {
      throw error instanceof Error
        ? error
        : new Error('Falha ao buscar relatório de colaboradores por setor.');
    }
    return ValidateAxiosError<RelatorioComarcasColaboradores[]>(
      error,
      'Falha ao buscar relatório de colaboradores por setor.',
    );
  }
}
